import {useCallback} from 'react'

// The ref needed for react-popper is a useState
// To accomadate for both this ref to work and have an actual ref to the DOM
// we have this hook that chooses the right type

export const useMergedRefs = (...refs) => {
	const setRefs = useCallback(node => {
		refs.forEach(ref => {
			if (!ref) return
			if (typeof ref === 'function') {
				ref(node)
			} else {
				ref.current = node
			}
		})
	}, refs)

	return setRefs
}
